import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";
import { ExpenseCategory, ExpenseCostType } from "./expenseService";

const api = new APIClient();

const RESOURCE = "/financial/unit-pl-report";

export interface UnitPlReportPeriod {
  from: string;
  to: string;
}

export interface UnitPlCategoryBreakdown {
  category: ExpenseCategory;
  total_cents: number;
}

export interface UnitPlCostTypeBreakdown {
  cost_type: ExpenseCostType;
  total_cents: number;
}

export interface UnitPlReport {
  unit_id: number;
  period: UnitPlReportPeriod;
  revenue_cents: number;
  expenses_cents: number;
  net_result_cents: number;
  expenses_by_category: UnitPlCategoryBreakdown[];
  expenses_by_cost_type: UnitPlCostTypeBreakdown[];
}

export interface UnitPlReportParams {
  unit_id: number;
  from: string;
  to: string;
}

export const getUnitPlReport = (
  params: UnitPlReportParams
): Promise<ApiResponse<UnitPlReport>> =>
  api.get<ApiResponse<UnitPlReport>>(RESOURCE, params);
